/**
 * react-query wiring for `/api/progress/overview` (brief §progress) and the
 * small slice of `/api/content/topics` (foundation) used for chapter/topic
 * display names. Query keys are namespaced `["progress", …]` per
 * `docs/CONVENTIONS.md`.
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "@client/api/client";
import { useTopicsAndChapters } from "@client/api/topics";
import type { ProgressOverview } from "./types";

export const progressKeys = {
  all: ["progress"] as const,
  overview: () => ["progress", "overview"] as const,
};

export function useProgressOverview() {
  return useQuery({
    queryKey: progressKeys.overview(),
    queryFn: () => api.get<ProgressOverview>("/api/progress/overview"),
  });
}

/**
 * Chapters + topics for display names. Shared hook (see `@client/api/topics`)
 * so practice, flashcards, progress and the home page share one cache entry.
 */
export { useTopicsAndChapters };
